import { Heading } from "@chakra-ui/react";

export const LB = () => (
  <>
    <br />
    <br />
  </>
);

export const H3 = ({ text }: { text: string }) => (
  <Heading as="h3" size="2xs" mt={4} mb={1}>
    {text}
  </Heading>
);
